import Layout from "components/layout";
import Sections from "components/sections";
import { getGlobalData } from "lib/storyblok/getGlobalData";
import { getGrowthmindedcfoPageData } from "lib/storyblok/getGrowthmindedcfoPageData";
import { getGrowthmindedcfoSlugs } from "lib/storyblok/getGrowthmindedcfoSlugs";
import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";

export default function DynamicPage({ globalData, pageData }) {
  const router = useRouter();

  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  return (
    <Layout {...globalData} {...pageData.content}>
      <Sections sections={pageData.content.body} />
    </Layout>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  const podcasts = await getGrowthmindedcfoSlugs();

  const paths = podcasts.map((podcast) => ({
    params: { slug: podcast.slug.split('/') },
    locale: podcast.locale,
  }));

  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async ({ params: { slug }, preview = false, locale }) => {
  const pageData = await getGrowthmindedcfoPageData(slug, { locale, preview });

  if (!pageData) {
    return {
      notFound: true,
    };
  }

  const globalData = await getGlobalData({
    locale,
    preview,
  });

  return {
    props: {
      globalData,
      pageData,
    },
  };
};
